import useAxiosInterceptor from 'src/services/interceptor';
import { mdsCommunication } from '../constants';

const { getMdsFormId, getAllMds, signMds, signerToMds, getMdsById, getMdsTypes, getMdsReformId } =
  mdsCommunication;

export type MdsSignType = {
  mdsFormId: string;
  param: object;
};

class MdsCommunicationService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getMdsFormId = (patientId: string, param: object) => {
    return this.axiosInstance.get(getMdsFormId(patientId), {
      params: param,
    });
  };

  getAllMdsForms = (patientId: string, params: object) => {
    return this.axiosInstance.get(getAllMds(patientId), {
      params,
    });
  };

  signMdsForm = (mdsFormId: string) => {
    return this.axiosInstance.put(signMds(mdsFormId));
  };

  addSignerToMdsForm = (payload: MdsSignType) => {
    return this.axiosInstance.put(signerToMds(payload.mdsFormId), null, {
      params: payload.param,
    });
  };

  getMdsById = (mdsId: string) => {
    return this.axiosInstance.get(getMdsById(mdsId));
  };

  getMdsType = (patientId: string) => {
    return this.axiosInstance.get(getMdsTypes(patientId));
  };

  getMdsReformId = (patientId: string) => {
    return this.axiosInstance.get(getMdsReformId(patientId));
  };
}

const mdsCommunicationService = new MdsCommunicationService();

Object.freeze(mdsCommunicationService);

export default mdsCommunicationService;
